import React from 'react';

import PropTypes from 'prop-types';

const Anchor = ({ id }) => (
    <div
        id={id}
        style={{ top: '-75px', width: '100vw', height: '0', opacity: '0', position: 'absolute' }}
    />
);

Anchor.propTypes = {
    id: PropTypes.string
};

export default Anchor;
